import React from 'react';
import { GlobeIcon } from 'lucide-react';
import { Reveal } from './Reveal';
export function GlobalCompatibilitySection() {
  return <section className="w-full bg-navy-900 pb-10 pt-2 lg:py-12" aria-labelledby="global-heading" data-id="element-42" data-mp="euoe50rvphf8">
      <div className="mx-auto max-w-5xl px-6 lg:px-8" data-id="element-43" data-mp="a1v9ecweu935">
        <Reveal data-id="element-44" data-mp="622uligfb6pc">
          <div className="rounded-2xl border border-brand-gold/25 bg-white/[0.04] p-6 sm:p-8" data-id="element-45" data-mp="62mfn81deb7l">
            <p className="flex items-center gap-2 text-xs font-bold uppercase tracking-[0.18em] text-brand-gold" data-id="element-46" data-mp="1302szpgewzb">
              
              🌍
WORLDWIDE TACTICAL COMPATIBILITY
            </p>
            <h2 id="global-heading" className="mt-3 text-xl font-extrabold leading-snug text-white sm:text-2xl" data-id="element-47" data-mp="3n9evkkeqhk5a">
              Built on elite US real estate standards. Designed for global dominance.
            </h2>
            <p className="mt-3 text-[15px] leading-relaxed text-slate-300" data-id="element-48" data-mp="1lhjxj7lehe5j">
              The AI prompts, psychological triggers, and automation workflows are 100% applicable to any market
              where speed, authority, and lead conversion are the keys to success.
            </p>
            <p className="mt-2 text-[15px] font-semibold leading-relaxed text-white" data-id="element-49" data-mp="r016w3pzxpqp">
              From North America to Europe, Africa, and Australia — the engine remains the same.
            </p>
          </div>
        </Reveal>
      </div>
    </section>;
}